<template>
  <div class="suggestions-container">
    <v-icon>
      far fa-lightbulb
    </v-icon>
    <h2>
      {{ $t('wdm.views.suggestions.labels.suggestions', 'Suggestions') }}
    </h2>
    <v-btn
      @click="selectPanel('template')"
      color="green"
      flat>
      {{ $t('wdm.views.suggestions.buttons.addTemplate', 'Add a template?') }}
      <v-icon
        small
        right>
        fas fa-pencil-ruler
      </v-icon>
    </v-btn>
    <v-btn
      @click="selectPanel('widget')"
      color="green"
      flat>
      {{ $t('wdm.views.suggestions.buttons.addWidget', 'Add a widget?') }}
      <v-icon
        small
        right>
        fas fa-swatchbook
      </v-icon>
    </v-btn>
    <v-btn
      @click="selectPanel('webapp-edition')"
      color="green"
      flat>
      {{ $t('wdm.views.suggestions.buttons.editWebAppInfo', 'Edit WebApp info?') }}
      <v-icon
        small
        right>
        fas fa-pen
      </v-icon>
    </v-btn>
    <v-btn
      flat
      color="green">
      {{ $t('wdm.views.suggestions.buttons.cloneWebApp', 'Clone your WebApp?') }}
      <v-icon
        small
        right>
        fas fa-clone
      </v-icon>
    </v-btn>
    <v-btn
      flat
      color="green">
      {{ $t('wdm.views.suggestions.buttons.showcaseWebApp', 'Showcase your WebApp?') }}
    </v-btn>
    <v-btn
      flat
      color="green">
      {{ $t(MORE_KEY, MORE_NATIVE) }}
    </v-btn>
    <br>
    <br>
    <v-btn
      flat>
      {{ $t('wdm.views.suggestions.buttons.renameSheet', 'Rename my sheet') }}
      <v-icon
        small
        right>
        far fa-file-excel
      </v-icon>
    </v-btn>
    <v-btn
      flat>
      {{ $t('wdm.views.suggestions.buttons.copySheet', 'Copy my sheet') }}
      <v-icon
        small
        right>
        far fa-copy
      </v-icon>
    </v-btn>
    <v-btn
      flat>
      {{ $t('wdm.views.suggestions.buttons.addDataGrid', 'Add a datagrid') }}
      <v-icon
        small
        right>
        fas fa-th
      </v-icon>
    </v-btn>
    <v-btn
      flat>
      {{ $t('wdm.views.suggestions.buttons.addGraph', 'Add a graph') }}
      <v-icon
        small
        right>
        fas fa-chart-pie
      </v-icon>
    </v-btn>
    <v-btn
      flat>
      {{ $t(MORE_KEY, MORE_NATIVE) }}
    </v-btn>
    <br>
    <br>
    <v-btn
      @click="selectPanel('collaboration')"
      color="orange"
      outline>
      {{ $t('wdm.views.suggestions.buttons.workWithOthers', 'Work with others') }}
      <v-icon
        small
        right>
        fas fa-users
      </v-icon>
    </v-btn>

    <br>
    <br>
    <v-btn
      @click="selectPanel('chat')"
      color="blue"
      outline>
      {{ $t('wdm.views.suggestions.buttons.needHelp', 'Need help?') }}
      <v-icon
        small
        right>
        far fa-question-circle
      </v-icon>
    </v-btn>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'Suggestions',
  data () {
    return {
      MORE_KEY: 'wdm.views.suggestions.buttons.more',
      MORE_NATIVE: 'More...'
    }
  },
  methods: {
    ...mapActions('wdm', [
      'selectPanel'
    ])
  }
}
</script>

<style lang="scss" scoped>
    @import "~common-assets/scss/we";
    .suggestions-container {
        text-align: center;
        padding: 10px;
        @extend .full-size;
        h2 {
            margin-bottom: 10px;
        }
        .v-btn {
            width: 100%;
            margin-left: 0;
            margin-right: 0;
            @extend .text-no-wrap;
        }
    }
</style>
